import styled from 'styled-components';
import variables from '../../../styles/variables';
import ButtonLink from '../../UI/ButtonLink/ButtonLink';
import mapPin from '../../../images/tms-store-icon-pin.svg';
import defaultPin from '../../../images/default-map-pin.svg';
import Arrow from '../../../images/Arrow_link_back.svg';
import { KioskProps } from '../../../types';

export const AdditionalStores = styled.ol`
  width: 100%;
  list-style: none;
  margin: 0;

  li {
    border-bottom: solid 1px rgba(51, 51, 51, 0.11);
    padding: 30px 0 20px;
    margin: 0;

    &:first-child {
      padding-top: 20px;
    }
  }

  &.map-list {
    li {
      &:first-child {
        padding-top: 30px;
      }
    }
  }

  &.appointment-form {
    margin-bottom: 0.5rem;
  }
`;

export const BladeButtonWrapper = styled.button<KioskProps>`
  width: 100%;
  cursor: ${({ isKiosk }) => (isKiosk ? 'initial' : 'pointer')};
  background: none;
  border: none;
`;

export const Time = styled.div`
  display: flex;

  p {
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  span.weekday {
    display: inline-block;
    min-width: 90px;
    margin-right: 40px;
    font-weight: 600;
  }

  span.time {
  }

  .green {
    color: #276600;
  }

  .red {
    color: #eb0000;
  }

  &.not-active {
    span {
      color: #515861;
    }
  }

  @media only screen and (min-width: 768px) {
    ${AdditionalStores}.map-list & {
      margin: 0 auto;
      min-width: 180px;

      p {
        font-size: 16px;
      }
    }
  }
`;

export const Store = styled.div`
  display: flex;
  flex-direction: column;

  ${AdditionalStores}.map-list & {
    justify-content: flex-start;
  }

  &.appointment-form {
    display: flex;
    flex-direction: column;

    @media only screen and (min-width: 1024px) {
      flex-direction: row;
      align-items: stretch;
      justify-content: flex-end;
    }
  }

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-end;

    ${AdditionalStores}.map-list & {
      justify-content: flex-start;
    }
  }
`;

export const StoreIdentifier = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  ${AdditionalStores}.map-list & {
    width: auto;
  }

  ${Store}.appointment-form & {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    @media only screen and (min-width: 1024px) {
      width: 45%;
      align-items: center;
      justify-content: flex-end;
    }
  }

  @media only screen and (min-width: 768px) {
    width: 45%;
    align-items: center;
    justify-content: flex-end;

    ${AdditionalStores}.map-list & {
      width: 40%;
    }
  }
`;

export const StoreContact = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  ${AdditionalStores}.map-list & {
    width: auto;
  }

  ${Store}.appointment-form & {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;

    @media only screen and (min-width: 1024px) {
      margin-top: 0;
      width: 55%;
      align-items: center;
    }
  }

  @media only screen and (min-width: 768px) {
    margin-top: 0;
    width: 55%;
    align-items: center;

    ${AdditionalStores}.map-list & {
      width: 60%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
`;

export const DistanceWrapper = styled.div<{ char: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;

  &::before {
    content: '${({ char }) => char}';
    text-align: center;
    color: #ffffff;
    background-image: url(${mapPin});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    min-width: 21px;
    height: 30px;
    margin-right: 10px;
    font-size: 12px;
    line-height: 1.75;
  }

  p {
    font-size: 16.6px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #333333;
  }

  ${AdditionalStores}.map-list & {
    &::before {
      background-image: url(${defaultPin});
    }
  }

  @media only screen and (min-width: 768px) {
    ${AdditionalStores}.map-list & {
      &::before {
        margin-right: 30%;
      }
    }
  }
`;

export const Icon = styled.div`
  width: 125px;
  height: 21px;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  ${Store}.appointment-form & {
    margin: 0;

    @media only screen and (min-width: 1024px) {
      margin: 0 auto;
    }
  }

  @media only screen and (min-width: 768px) {
    margin: 0 auto;
  }
`;

export const Location = styled.div<{isKioskWelcome?: boolean;}>`
  ${({ isKioskWelcome }) => isKioskWelcome && `display: flex;`}
  > p {
    font-size: 13px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #333333;
    margin-bottom: 0.3rem;
    text-align: left;
  }

  @media only screen and (min-width: 768px) {
    width: 200px;
    > p {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
    }

    ${AdditionalStores}.map-list & {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;

      > p {
        width: 210px;
      }
    }
  }
`;

export const SelectBtn = styled(ButtonLink)<{isKioskWelcome?: boolean;}>`
  margin-left: 18px;
  padding: ${({ isKioskWelcome }) => isKioskWelcome ? '0px' : '0 20px'};

  &:lang(en) {
    white-space: nowrap;
  }

  &:focus,
  &:hover,
  &.active {
    background-color: ${variables.colorBlack} !important;
    color: ${variables.colorWhite} !important;
  }
`;

export const ContactUsLink = styled.a`
  text-decoration: none;
`;

export const Chevron = styled.div`
  all: unset;
  width: 2rem;

  &:before {
    border-style: solid;
    border-width: 0.1em 0.1em 0 0;
    border-color: #7c7f83;
    content: '';
    display: inline-block;
    height: 0.8em;
    position: relative;
    top: 0.15em;
    transform: rotate(-45deg);
    vertical-align: top;
    width: 0.8em;
    left: 0;
    transform: rotate(45deg);
  }
`;

export const VirtualMobilistArrow = styled.span`
  font-size: 14px;
  font-weight: 600;
  height: 40px;
  color: ${variables.colorRed};
  text-decoration: none;
  display: flex;
  justify-self: start;
  align-items: center;
  margin-bottom: 0;
  border: none;
  padding-right: 5px;
  width: 45%;
  text-align: right;
  &:hover {
    text-decoration: underline;
  }
  &:after {
    content: '';
    display: block;
    width: 10px;
    height: 8px;
    position: relative;
    right: -5px;
    background: url(${Arrow}) no-repeat scroll 0 0 transparent;
    background-position: center;
    transform: rotate(180deg);
  }
  @media screen and (max-width: 768px) {
    grid-area: back;
  }
`;
